module.exports = __webpack_public_path__ + "static/media/ff-mother.9057dd84.jpg";